import { render, staticRenderFns } from "./OpcionPago.vue?vue&type=template&id=1b8c819e&"
import script from "./OpcionPago.vue?vue&type=script&lang=js&"
export * from "./OpcionPago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports